import React, { useState } from "react";

import { Button, Caption, Flex, Input, Toggle } from "@olist/design-system";

import { LisChat } from "./components";
// import { RemoteChat } from "../../components/remote-components/chat-instance";

export function ChatPage() {
  const [isOpen, setIsOpen] = useState(false);
  const [theme, setTheme] = useState<"light" | "dark">("light");
  const [checked, setChecked] = useState(true);
  const [isPortal, setIsPortal] = useState(false);
  const [token, setToken] = useState("");

  const handleOpenDrawer = () => {
    const newState = !isOpen;
    setIsOpen(newState);
  };

  const toggleTheme = () => {
    if (theme === "dark") {
      setChecked(true);
      return setTheme("light");
    }
    setChecked(false);
    return setTheme("dark");
  };

  const handleClose = () => {
    if (isPortal) {
      setIsPortal(false);
    }
    if (isOpen) {
      setIsOpen(false);
    }
  };

  return (
    <>
      <Flex gap="stack.medium">
        <Button onClick={handleOpenDrawer}>Abrir Drawer</Button>
        <Flex
          gap="stack.small"
          border="1px solid black"
          alignItems="center"
          paddingHorizontal="inline.small"
          paddingVertical="stack.2xsmall"
          borderRadius="pill"
          backgroundColor="neutral.softer"
        >
          <Caption>🌙</Caption>
          <Toggle checked={checked} onChange={toggleTheme} />
          <Caption>🌞</Caption>
        </Flex>
        <Button onClick={() => setIsPortal(true)}>Abrir como Portal</Button>
      </Flex>
      <Flex marginVertical="stack.large">
        <Input
          label="access-token"
          value={token}
          onChange={({ target }) => setToken(target.value)}
        />
      </Flex>
      <LisChat
        theme={theme}
        isOpen={isOpen}
        onClose={handleClose}
        isPortal={isPortal}
        accessToken={token}
      />
      {/* <RemoteChat
        theme={theme}
        isOpen={isOpen}
        onClose={handleClose}
        isPortal={isPortal}
        accessToken={token}
      /> */}
    </>
  );
}
